module.exports = __webpack_public_path__ + "static/media/gal-12.0709a3b0.jpeg";